import { connect } from 'react-redux';

import AuthorizedRoute from './AuthorizedRoute';
import { selectors } from '../../dux/user';

const mapStateToProps = (state) => ({
  userPerms: selectors.getIdentityState(state).permissions,
  userRoles: selectors.getIdentityState(state).roles,
  isAuthenticated: selectors.isAuthenticated(state),
  organizationId: selectors.getIdentityState(state).organizationId,
});

export default connect(mapStateToProps, {})(AuthorizedRoute);
